import React, { useEffect, useState } from 'react'
import { MdArrowDownward, MdArrowUpward } from 'react-icons/md'
import { Button } from './styled'

export default function ScrollArrow() {
  const [isTop, setIsTop] = useState(true)
  const [isBottom, setIsBottom] = useState(false)

  const handleUp = () => {
    const { innerHeight, scrollY } = window
    window.scrollTo({ top: scrollY - innerHeight, behavior: 'smooth' })
  }
  const handleDown = () => {
    const { innerHeight, scrollY } = window
    window.scrollTo({ top: scrollY + innerHeight, behavior: 'smooth' })
  }

  useEffect(() => {
    const handleScroll = () => {
      const { innerHeight, scrollY } = window

      if (scrollY === 0) {
        setIsTop(true)
        setIsBottom(false)
      }

      if (scrollY > 0) {
        setIsTop(false)
        setIsBottom(false)
      }

      if (scrollY + innerHeight === document.body.scrollHeight) {
        setIsTop(false)
        setIsBottom(true)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <>
      <Button className={`scroll-arrow__up ${isTop ? 'hidden' : ''}`} onClick={handleUp}>
        <MdArrowUpward />
      </Button>

      <Button className={`scroll-arrow__down ${isBottom ? 'hidden' : ''}`} onClick={handleDown}>
        <MdArrowDownward />
      </Button>
    </>
  )
}
